'use client';

import { COLORS } from '@/constants';
import { Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { useRouter } from 'next/navigation';
import { PATHS } from '@/constants';
import {
  WelcomeBannerButton,
  WelcomeBannerContent,
  WelcomeBannerIllustration,
  WelcomeBannerWrapper,
} from '../styled';
import brokerWelcomeBannerSvg from '@/assets/svg/broker-bg-figure.svg';

/* TODO: replace with actual pen icon from project icons */
const PenPlaceholderIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);

/* TODO: replace with actual illustration asset */
const _BannerIllustration: FC = () => (
  <svg
    width="280"
    height="100%"
    viewBox="0 0 280 176"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ position: 'absolute', right: 0, top: 0, bottom: 0, height: '100%' }}
    preserveAspectRatio="xMaxYMid meet"
  >
    {/* Background circles */}
    <circle cx="220" cy="88" r="130" fill={COLORS['primary/800']} fillOpacity="0.4" />
    <circle cx="220" cy="88" r="95" fill={COLORS['primary/700']} fillOpacity="0.3" />
    <circle cx="220" cy="88" r="60" fill={COLORS['primary/700']} fillOpacity="0.2" />
    {/* Abstract geometric shapes (terracotta/brown tones like in screenshot) */}
    <ellipse cx="200" cy="130" rx="30" ry="20" fill={COLORS['secondary/400']} fillOpacity="0.6" />
    <rect
      x="185"
      y="90"
      width="22"
      height="45"
      rx="2"
      fill={COLORS['brown/400']}
      fillOpacity="0.7"
    />
    <rect
      x="210"
      y="105"
      width="16"
      height="30"
      rx="2"
      fill={COLORS['brown/300']}
      fillOpacity="0.5"
    />
    {/* Leaf/plant placeholder */}
    <path d="M215 70 Q230 50 245 65 Q230 80 215 70Z" fill={COLORS['brown/300']} fillOpacity="0.4" />
    <path d="M220 75 Q240 55 255 72 Q238 85 220 75Z" fill={COLORS['brown/100']} fillOpacity="0.3" />
    <line
      x1="220"
      y1="75"
      x2="220"
      y2="110"
      stroke={COLORS['brown/300']}
      strokeWidth="1.5"
      strokeOpacity="0.5"
    />
  </svg>
);

export const WelcomeBanner: FC = () => {
  const t = useTranslations('dashboard');
  const router = useRouter();

  return (
    <WelcomeBannerWrapper>
      <WelcomeBannerIllustration>
        <img src={brokerWelcomeBannerSvg.src} alt="" />
      </WelcomeBannerIllustration>

      <WelcomeBannerContent>
        <Typography
          fontSize={32}
          fontWeight={700}
          color={COLORS.white}
          lineHeight={1.4}
          marginBottom={'8px'}
        >
          {t('welcome')}
        </Typography>

        <Typography
          fontSize={20}
          fontWeight={600}
          color={COLORS['beige-silver']}
          lineHeight={1.3}
          marginBottom={'24px'}
        >
          {t('welcomeSubtitle')}
        </Typography>

        <WelcomeBannerButton
          type="button"
          onClick={() => router.push(`/profile/${PATHS.MEMBER_PROFILE}/edit`)}
        >
          <PenPlaceholderIcon />
          {t('editBrokerData')}
        </WelcomeBannerButton>
      </WelcomeBannerContent>
    </WelcomeBannerWrapper>
  );
};
